// core version + navigation, pagination modules:
import Swiper from 'swiper'
import {Autoplay, Navigation, Pagination} from 'swiper/modules'

export default class Sliders {
  constructor(slider, index) {
    this.slider = slider
    this.index = index
    this.slides = Array.from(this.slider.querySelectorAll('.swiper-slide'))

    this.options = this.setOptions()
    this.initSlider()
  }

  setOptions() {
    let options = {}

    if (this.slider.classList.contains('swiper--numbers')) {
      options = {
        modules: [Autoplay, Pagination],
        autoplay: {
          delay: 8000,
        },
        keyboardControl: true,
        slidesPerView: 1,
        spaceBetween: 20,
        watchOverflow: true,
        pagination: {
          el: '.swiper-pagination--numbers',
          type: 'bullets',
        },
      }
    } else if (this.slider.classList.contains('swiper--experience')) {
      options = {
        modules: [Navigation],
        navigation: {
          nextEl: '.swiper-button-next--experience',
          prevEl: '.swiper-button-prev--experience',
        },
        slidesPerView: 1,
        spaceBetween: 30,
        watchOverflow: true,
        breakpoints: {
          768: {
            slidesPerView: 'auto',
            spaceBetween: 50,
          },
        },
      }
    } else if (this.slider.classList.contains('swiper--team')) {
      options = {
        modules: [Navigation],
        navigation: {
          nextEl: '.swiper-button-next--team',
          prevEl: '.swiper-button-prev--team',
        },
        slidesPerView: 1,
        spaceBetween: 20,
        watchOverflow: true,
        breakpoints: {
          768: {
            slidesPerView: 'auto',
            spaceBetween: 60,
          },
        },
      }
    } else if (this.slider.classList.contains('swiper--circular')) {
      options = {
        modules: [Autoplay],
        autoplay: {
          delay: 4000,
          // reverseDirection: true,
        },
        loop: true,
        slidesPerView: 1,
        spaceBetween: 20,
        watchOverflow: true,
      }
    } else if (this.slider.classList.contains('swiper--double')) {
      options = {
        modules: [Autoplay, Navigation],
        autoplay: {
          delay: 9000,
        },
        loop: true,
        navigation: {
          nextEl: '.swiper-button-next--double',
          prevEl: '.swiper-button-prev--double',
        },
        slidesPerView: 1,
        spaceBetween: 20,
        watchOverflow: true,
      }
    } else if (this.slider.classList.contains('swiper--quote')) {
      options = {
        modules: [Navigation],
        loop: true,
        navigation: {
          nextEl: '.swiper-button-next--quote',
          prevEl: '.swiper-button-prev--quote',
        },
        slidesPerView: 1,
        watchOverflow: true,
      }
    } else if (this.slider.classList.contains('swiper--gallery')) {
      options = {
        modules: [Navigation],
        loop: true,
        navigation: {
          nextEl: '.swiper-button-next--gallery',
          prevEl: '.swiper-button-prev--gallery',
        },
        slidesPerView: 1,
        watchOverflow: true,
      }
    }

    return options
  }

  initSlider() {
    console.debug('  -> Sliders init')
    let swiperInstance = new Swiper(this.slider, this.options)
    swiperInstance.init()
    this.swiperInstance = swiperInstance
  }

  destroy() {
    console.debug('  -> Sliders destroy', this.node)
    this.swiperInstance.destroy()
  }

  static destroyAll() {
    console.debug('  -> Sliders destroy all')
    Sliders.items.forEach((slider) => {
      slider.destroy()
    })
  }

  static init() {
    console.debug('== Sliders components ==')
    Sliders.items = Array.from(document.querySelectorAll('.swiper')).map(
      (slider, index) => new Sliders(slider, index)
    )
  }
}
